module.exports = __webpack_public_path__ + "img/2-valon-luo.1561b3f2.jpg";